import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createAssigmentApprovalUnit } from '@api/assignApprovalUnit';

import { ICreateApprovalUnitDTO } from '@interfaces/organisation/dto/approvalUnitsDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSIGN_APPROVAL_UNITS,
	ATTACHED_TYPES_SUBTYPES,
	CREATE_ASSIGNMENT_APPROVAL_UNIT,
	FILTER_ASSIGN_APPROVAL_UNITS,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateAssigmentApprovalUnit = (onSettledCallbacks: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleCreateAssignApprovalUnit,
		isLoading: isLoadingCreateAssignApprovalUnit,
	} = useMutation<ICreateApprovalUnitDTO>({
		mutationKey: [CREATE_ASSIGNMENT_APPROVAL_UNIT],
		mutationFn: createAssigmentApprovalUnit,
		onSuccess: () => {
			onSettledCallbacks.forEach((callback) => callback());

			dispatch(
				setSnackbar({
					message: responseMessages.createAssignmentApprovalUnit,
					type: ESnackbarTypes.success,
				}),
			);

			return [
				queryClient.invalidateQueries([ASSIGN_APPROVAL_UNITS]),
				queryClient.invalidateQueries([ATTACHED_TYPES_SUBTYPES]),
				queryClient.invalidateQueries([FILTER_ASSIGN_APPROVAL_UNITS]),
			];
		},
	});

	return {
		isLoadingCreateAssignApprovalUnit,
		handleCreateAssignApprovalUnit,
	};
};
